import { initializeNetworkConfig } from './initializeNetworkConfig';
import { JQueryWrapper } from '../JQueryWrapper';

export const NetworkConfig = () => {
  return JQueryWrapper({ executeJQueryLogic: initializeNetworkConfig });
};
